import { Stack, Typography } from "@mui/material";
import { memo, useState } from "react";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import PageTabs from "../../../../common/PageTabs";
import { PersistedTabPanel } from "../../../../common/PersistedTabPanel";
import NewFilterWidget from "./NewFilterWidget";
import NewWidget from "./NewWidget";
import Search from "./Search";
import SmartViewReports from "./SmartViewReports";

type Tabs = "Widgets" | "Settings";
const tabPanelSx = { height: "100%", gap: 2, flexDirection: "column" };

const WidgetsToolbar = memo(function WidgetsToolbar() {
  const [selectedTab, setSelectedTab] = useState<Tabs>("Widgets");
  const [search, setSearch] = useState("");

  return (
    <Stack
      sx={{
        display: "flex",
        flex: 1,
        pt: 2,
      }}
    >
      <PageTabs
        tabs={["Widgets", "Settings"]}
        labels={["Widgets", "Settings"]}
        value={selectedTab}
        onChange={setSelectedTab}
        disabledTabs={["Settings"]}
      >
        <PersistedTabPanel value="Widgets" selectedTab={selectedTab} sx={tabPanelSx}>
          <Search onSearch={setSearch} />
          <Stack sx={{ px: 2, pb: 1.5, gap: 2, height: "100%" }}>
            <NewWidget />
            <NewFilterWidget />
            <ScrollableFlexContainer>
              <SmartViewReports search={search} />
            </ScrollableFlexContainer>
          </Stack>
        </PersistedTabPanel>
        <PersistedTabPanel value="Settings" selectedTab={selectedTab} sx={tabPanelSx}>
          <Typography variant="h6">Settings</Typography>
        </PersistedTabPanel>
      </PageTabs>
    </Stack>
  );
});

export default WidgetsToolbar;
